<template>
 <div style="position: relative;    padding-top: 45px; background-color: #fff;" :style="{height:boxHeight}" v-cloak>
    <div class="mask" id="mask" v-show="technologicalStatusMask" @clcik="technologicalClick(false)"></div>

    <span class="spinner-border spinner-border-sm " role="status" aria-hidden="true" v-if="technologicalStatusMask1" style="width: 7rem;height: 7rem"></span>
    <div class="main center-m"  >
       
        <!--    遮罩层-->

        <!--    成功后弹框-->
        <transition name="slide" mode="out-in">
            <div class="modal-pop "   v-show="technologicalStatus"   id="modal-pop" :style="{ height: modalBoxHeight+'px'}">
            <div class="modal-pop-pop" v-show="errorStatus"></div>
                <div class="close-icons" @click="closePop()">
                </div>
                <div class="modal-main m-30" :style="{ height: modalHeight+'px'}">
                    <span class="font-size-big font-weight--bold block">标书啄木鸟</span>
                    <span class="font-size-normal block c-normal">三步完成投标文件打分</span>
                    <div class="modal-process">
                        <!-- <img :src="fifterImg"/> -->
                        <img v-if="nextIndex == 0" src="../../assets/zmning/icon0.png"/>
                        <img v-if="nextIndex == 1" src="../../assets/zmning/icon1.png"/>
                        <img v-if="nextIndex == 2" src="../../assets/zmning/icon2.png"/>
                    </div>
                    <!--`                   用户步骤 ->> 1-->
                    <div v-if="nextIndex == 0">
                        <!--                            <div class="modal-mask" v-if="modal0pre.status">-->
                        <!--                                <div class="spinner-border spinner-border-sm modal-pop&#45;&#45;loding " role="status" v-if="modal0pre.status" style="width: 3rem; height: 3rem;">-->
                        <!--                                    <span class="sr-only">Loading...</span>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <div class="modal-process-box">

                            <el-tooltip class="item" content="" placement="left" popper-class="atooltip1">
                                <div slot="content">请在模板中填写评标模板内<br/>容,勿修改模板格式</div>
                                <div class="modal-process-box--left  ">
                                    <img src="../../assets/zmning/icon_window_down@3x.png" alt="" >

                                    <div class="modal-process-box-span download" >
                                        <span>
                                            <a href="/zcjf/biz/bfe/guarantee/bidingCheck/downloadFile" ><span>点我下载</span></a>
                                            <a href="/zcjf/biz/bfe/guarantee/bidingCheck/downloadFile" ><span>评标条款模板</span></a>
                                        </span>
                                    </div>
                                </div>
                            </el-tooltip>
                            
                            <div class="modal-process-box--p">
                                <span class="c-999 font-size-normal ">填完后上传</span>
                                <img src="../../assets/zmning/size.png" alt="" class="modal-process-box-size">
                            </div>
                            <el-tooltip class="item" content="" placement="right" popper-class="atooltip2">
                            <div slot="content">上传文件必须按照模板填<br/>写,格式为Excel</div>
                            <div>
                              　<label for="up">
                                <div class="modal-process-box--right " style="cursor: pointer" >
                                    <img src="../../assets/zmning/icon_window_upload@3x.png" alt="" v-if="!modal0pre.status">
                                    <img src="../../assets/zmning/loading.gif" alt="" v-if="modal0pre.status">
                                    <div class="modal-process-box-span"><p>点我上传</p><p>评标条款</p></div>
                                    <input class="file" name="file" type="file"  accept="application/vnd.ms-excel"  @change="update" v-show="false" id="up" />
                                    <div class="flex">
                                        <span class="ell spanw" v-show="delectStatus==1">{{imgSataus}}</span>
                                        <span class="ell spanw" v-show="delectStatus==0">未上传</span>
                                        <span class="ell spanw" v-show="delectStatus==2">正在上传</span>
                                        <span class="ell spanw" v-show="delectStatus==3">文件已上传请等待</span>
                                        <span v-if="delectStatus==1"   @click.stop.prevent="delectFile($event)" style="color: red">删除</span>
                                    </div>
                                </div>
                            </label>
                            </div>
                           </el-tooltip>
                            
                        </div>
                        　<label for="bidding">
                            <div class="modele-box--end bidding" style="cursor: pointer">
                                <img src="../../assets/zmning/icon_window_upload@3x.png" alt="" v-if="!modal3pre.status" style="width: 60px;height: 60px">
                                <img src="../../assets/zmning/loading.gif" alt="" v-if="modal3pre.status" style="width: 60px;height: 60px">
                                <div class="flex-colum" style="align-items: flex-start;"><span class="font-size-big font-weight--bold c-blue" style="color: #007bff">点我上传招标文件</span>
                                <span class="font-size-normal">为提升分析的准确度,</span>
                                <span class="font-size-normal">请上传完整的招标文件(仅支持pdf格式)</span></div>
                                <input class="file" name="file" type="file"  @change="updateM3('1')" v-show="false" id="bidding" accept="application/pdf"/>
                                 
                                 <div class="flex">
                                    <span class="ell spanw" v-show="Modal2delectStatus == 0">{{Modal2delectStatusImgStatus}}</span>
                                    <span class="ell spanw" v-show="Modal2delectStatus == 1">未上传</span>
                                    <span class="ell spanw red" v-show="Modal2delectStatus == 2">上传中{{msgloding}}%</span>
                                    <span v-if="Modal2delectStatus == 0"   @click.stop.prevent="delectFileModal2($event)" style="color: red">删除</span>
                                </div>
                            </div>
                        </label>
                        <span class="tell">1、下载的Excel文件请不要修改格式，上传文件也要为Excel格式</span>
                        <span class="tell">2、只支持以下类型的标段：工程大类型下的公路、房建市政、房屋建筑,才能进行智能估分</span>

                    </div>
                    <!--`                   用户步骤 ->> 2-->
                    <div v-if="nextIndex == 1 ">
                        <div class="mt-15">
                            <span class="font-size-normal font-weight--bold">投标人姓名<span class="c-red"> * </span></span>
                            <span class=" font-size-normal ml-15"  v-if="fromData.name.state " :style="{'color': (fromData.name.rules == true ? 'green':'red')}">{{fromData.name.rules == true ? "校验通过":"必填项目不能为空"}}</span>
                            <input  maxlength="50" v-model="fromData.name.text" type="text" class="form-control mt-15" placeholder="请填写投标人姓名" aria-describedby="sizing-addon1" style="background: #EEEEEE;font-size: 14px;">
                        </div>
                        <div class="mt-15">
                            <span class="font-size-normal font-weight--bold">投标人手机号 <span class="c-red"> * </span> </span>
                            <span class="font-size-normal ml-15" v-if="fromData.phone.state"  :style="{'color': (fromData.phone.rules == true ? 'green':'red')}">{{fromData.phone.rules == true ? "填写格式正确":"请重新检查您的手机号是否正确"}}</span>
                            <input  oninput="value=value.replace(/[^\d]/g,'')"  v-model="fromData.phone.text" type="text" class="form-control mt-15" placeholder="请填写投标人手机号" aria-describedby="sizing-addon1" style="background: #EEEEEE;font-size: 14px;">
                        </div>
                        <div class="mt-15">
                            <span class="font-size-normal font-weight--bold">项目/标段名称</span>
                            <!--                                <span  class=" font-size-normal ml-15" v-if="fromData.projectName.rules" :style="{'color': (fromData.phone.projectName == true ? 'green':'red')}"></span>-->
                            <input maxlength="200"  v-model="fromData.projectName.text" type="text" class="form-control mt-15" placeholder="请填写项目/标段名称" aria-describedby="sizing-addon1" style="background: #EEEEEE;font-size: 14px;">
                        </div>
                        <div class="mt-15">
                            <span class="font-size-normal font-weight--bold">投标人名称</span>
                            <!--                                <span  class=" font-size-normal ml-15" v-if="fromData.projectManName.rules" :style="{'color': (fromData.phone.projectManName == true ? 'green':'red')}"></span>-->
                            <input  maxlength="200" v-model="fromData.projectManName.text" type="text" class="form-control mt-15" placeholder="请填写投标人名称" aria-describedby="sizing-addon1" style="background: #EEEEEE;font-size: 14px;">
                        </div>
                        <div class="mt-15">
                            <span class="c-red font-size-normal--16">注：带*号为必填选项</span>
                        </div>
                    </div>
                    <div v-if ="nextIndex == 2" >
                        <span class="font-size-normal block c-normal mt-15 c-blue">上传您的投标文件</span>
                      　<label for="get">
                        <div class="modele-box--end" style="cursor: pointer">
                            <img src="../../assets/zmning/icon_window_upload@3x.png" alt="" v-if="!modal2pre.status" style="width: 60px;height: 60px">
                            <img src="../../assets/zmning/loading.gif" alt="" v-if="modal2pre.status" style="width: 60px;height: 60px">
                            <div class="flex-colum" style="align-items: flex-start;"><span class="font-size-big font-weight--bold c-blue" style="color: #007bff">上传投标文件</span><span class="font-size-normal">投标文件要求完整pdf文档</span></div>
                            <input class="file" name="file" type="file"  @change="updateM3" v-show="false" id="get" accept="application/pdf"/>
                            <div class="flex">
                                <span class="ell spanw" v-show="Modal3delectStatus == 0">{{Modal3delectStatusImgStatus}}</span>
                                <span class="ell spanw" v-show="Modal3delectStatus == 1">未上传</span>
                                <span class="ell spanw red" v-show="Modal3delectStatus == 2">上传中{{msgloding}}%</span>
                                <span v-if="Modal3delectStatus == 0"   @click.stop.prevent="delectFileModal3($event)" style="color: red">删除</span>
                            </div>
                        </div>
                    </label>
                    </div>
                </div>
                <div  >
                    <div v-if="nextIndex == 0" :class="[nextStepStatus0 == true ? 'modal-foote-center':'modal-foote']">
                        <div class="flex ml-15" >
                            <div class="progress " style="background: #fff" v-if="modal0pre.status"><div class="progress-bar" :style="{ width:progressMsg+'%'}"><span class="sr-only" ></span></div></div>
                            <span v-if="modal0pre.status" class="befor">{{progressMsg}}<span class="afer">%</span></span>
                        </div>
                        <button :disabled="Modal2delectStatusImgStatus===''|| imgSataus===''" :class="[Modal2delectStatusImgStatus===''|| imgSataus===''?  'Disable-btn btn btndis btn-over radius dis': 'normal-btn btn btndis btn-primary radius nor']" @click="nextStepClick(0)" >
                            <span class="spinner-border spinner-border-sm loding" role="status" aria-hidden="true" v-if="modal0pre.status"></span>
                            <span>下一步</span>
                        </button>
                    </div>
                    <div v-if="nextIndex == 1" class="modal-foote">
                        <div class="flex ml-15" >
                        </div>
                        <div class="normal-btn btn btn-outline-primary radius btndis btnpdnone" @click="backStepClick(1)" v-if="EchoState" style="padding: 0.5rem 0.5rem;">上一步</div>
                        <button :disabled="modal1pre.status" :class="[nextStepStatus1 == false ?  'Disable-btn btn  btn-over radius dis btndis': 'normal-btn btn btndis btn-primary radius nor']" @click="nextStepClick(1)" >
                            <span class="spinner-border spinner-border-sm loding" role="status" aria-hidden="true" v-if="modal1pre.status" ></span>
                            <span>下一步</span>
                        </button>
                    </div>
                    <div v-if="nextIndex == 2" class="modal-foote">
                        <div class="flex ml-15" >
                        </div>
                        <div  class="normal-btn btn btn-outline-primary radius btndis btnpdnone" @click="backStepClick(2)" v-if="EchoState" style="padding: 0.5rem 0.5rem;">上一步</div>
                        <button   :class="[nextStepStatus2 == false ?  'Disable-btn btn btndis btn-over radius dis ': 'normal-btn btn btn-primary radius nor btndis ']" @click="nextStepClick(2)" >
                            <span class="spinner-border spinner-border-sm loding" role="status" aria-hidden="true" v-if="modal2pre.status"></span>
                            <span>提交申请</span>
                        </button>
                    </div>
                </div>
            </div>
        </transition >
        <transition name="slide" mode="in-out">
            <div class="result-modal-box" v-if="resultState">
                <img :src="overImg" alt="" class="mt-15" style="width: 69px;">
                <span class="font-size-normal--16 font-weight--bold mt-15">{{result_msg}}</span>
                <span class="font-size-normal mt-15">{{result_detail}}</span>
                <div class="normal-btn btn btn-primary   btndis radius mt-15" style="width: 320px" @click="result_over">
                    <span class="spinner-border spinner-border-sm loding" role="status" aria-hidden="true" v-if="modal2pre.status"></span>
                    <span>确定</span>
                </div>
            </div>
        </transition>
        <transition name="slide" mode="in-out">
            <div class="result-modal-box" v-if="errorStatus">
                <span class="font-size-normal--16 font-weight--bold mt-15">{{errortext}}</span>
                <div class="normal-btn btn btn-primary   btndis radius mt-15" style="width: 320px" @click="errorStatusOver">
                    <span>我知道了</span>
                </div>
            </div>
        </transition>
        <!--    modal 模拟弹框-->
        <div class="bander-main flex">
            <div class="bander-main-left "></div>
            <div class="bander-main-right">
                <span class="bander-main-right--number">{{freetime}}</span>
                <span class="bander-main-right--lastcheck">剩余免费次数</span>
                <div class="bander-main-right-btn" @click="gets(true)"   style="cursor: pointer">立即申请</div>
            </div>
        </div>
        <div class="list-main " v-show="resultDataMsgStatus">
            <span class="font-size-big mt-30 m-b font-weight--bold block">我的申请报告</span>
            <div >

                <table class="table table-border " style="   border-collapse: collapse;table-layout: fixed;">
                    <thead>
                    <tr class="text-c" style="line-height: 79px;">
                        <th>序号</th>
                        <th>标段名称</th>
                        <th>联系人</th>
                        <th>联系人手机号码</th>
                        <th>投标公司名称</th>
                        <th>状态</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="active text-c " v-for="(tableItem,index) in tableList " :key="index">
                        <th  >{{index+1}}</th>
                        <td ><span class="tablelist" :title="tableItem.packageName || '暂无信息'">{{tableItem.packageName  || '暂无信息'}}</span></td>
                        <td ><span class="tablelist" :title="tableItem.linkName || '暂无信息'">{{tableItem.linkName || '暂无信息'}}</span></td>
                        <td ><span class="tablelist" :title="tableItem.linkPhone || '暂无信息'" >{{tableItem.linkPhone  || '暂无信息'}}</span></td>
                        <td ><span class="tablelist" :title="tableItem.companyName || '暂无信息'"> {{tableItem.companyName  || '暂无信息 '}}</span></td>
                        <td ><span class="tablelist" :title="resultData[tableItem.orderStatus]" :class="resultDataBtnclass[tableItem.orderStatus]">{{resultData[tableItem.orderStatus]}}</span></td>
                        <td>
                            <div style="display: inline-block">
                                <!--                            <a :href="'/download?'+tableItem.pdfFileId" >-->
                                <div class="btn-normal" :class="btnData[tableItem.orderStatus] " type="button" @click="getStatusNextClick(tableItem,tableItem.orderStatus,tableItem.pdfId)">
                                    <!-- <img :src="resultImg(tableItem.orderStatus)"  style=" width: 16px;height: 16px;" alt=""> -->
                                    <img v-if="tableItem.orderStatus == 0 || tableItem.orderStatus == 1" src="../../assets/zmning/icon-process.png"  style=" width: 16px;height: 16px;" alt="">
                                    <img v-else src="../../assets/zmning/iconOver.png"  style=" width: 16px;height: 16px;" alt="">
                                    
                                    <span>{{ operation_status_Data[tableItem.orderStatus ]}}</span>
                                </div>
                                <!--                            </a>-->
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <!-- <div class="page"  v-show="show">
                    <div class="pagelist">
                        <span class="jump" :class="{disabled:pstart}" @click="gopageBack">上一页</span>
                        <span v-show="pageIndex>5" class="jusmp" @click="jumpPage(1)" style="cursor: pointer">首页</span>
                        <span class="ellipsis"  v-show="efont" style="cursor: pointer">...</span>
                        <span class="jump" v-for=" (num,index) in indexs" :class="{bgprimary:pageIndex==num}" @click="jumpPage(num)" :key="index">{{num}}</span>
                        <span class="ellipsis"  v-show="ebehind">...</span>

                        <span :class="{disabled:pend}" class="jump" @click="gopageNext">下一页</span>
                        <span v-show="pageIndex<pagesize-4" class="jump" @click="jumpPage(pagesize)">{{pagesize}}</span>

                        <span class="jumppoint">跳转到：</span>
                        <span class="jumpinp"><input type="number" v-model="changePage"></span>
                        <span class="jump gobtn" @click="jumpPage(changePage)">GO</span>
                    </div>
            </div> -->
           <div class="order-pagination">
            <el-pagination
                background
                hide-on-single-page
                layout="prev, pager, next"
                :page-size="pagination.size"
                :current-page.sync="pagination.current"
                :total="pagination.total"
                @current-change="handleSearch"
            >
            </el-pagination>
            </div>
            </div>
<!--            <nav aria-label="Page navigation example">-->
<!--                <ul class="pagination justify-content-center">-->
<!--&lt;!&ndash;                    <li class="page-item " >&ndash;&gt;-->
<!--&lt;!&ndash;                        <a class="page-link"  tabindex="-1" aria-disabled="true" @click="gopageBack()">上一页</a>&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--                    <li class="page-item flex"  ><a class="page-link" href="#"{{index+1}}</a></li>-->
<!--&lt;!&ndash;                    <li class="page-item">&ndash;&gt;-->
<!--&lt;!&ndash;                        <a class="page-link"  @click="gopageNext()" >下一页</a>&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--                </ul>-->
<!--            </nav>-->
        </div>
        <div class="resultDataMsgStatus" v-show="!resultDataMsgStatus">
            <img src="../../assets/zmning/icon_niao_list_nothing.png" alt="" >
            <div style="font-size: 17px">暂无申请报告</div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src

import { queryOrderMessage, judgeFreeTimes ,getFreeTimes, saveOrder, selectOrderMessage} from '../../api/bidWoodpecker.js'
import { download } from '@/shared/file'
import axios from 'axios'
export default {
  name: 'Home',
  components: {
  
  },
  data () {
    return {
        dataList:[],
        tenderFileId:'',
        fileModal2Soure:'',
        Modal2delectStatus:'1',
        Modal2delectStatusImgStatus:'',
        pagination: {
            size: 5,
            current: 1,
            total:1,
        },
        errorStatus:false,
            freetime:0,
            boxHeight:'900px',
            resultDataMsgStatus:true,
            resultData:[
                "待填写联系人信息",
                "待上传投标文件",
                "申请完成",
                "报告生成中",
                "报告生成失败",
                "报告已生成",
            ],
            number_active:0,
            resultDataBtnclass:["green ","green","c-red", "green",  "c-red","c-blue",],
            pagesize:1,
            errortext:'',
            operation_status_Data:["继续申请","继续申请","下载报告","下载报告","生成失败","下载报告"],
            btnData:[
                "btn-process","btn-process","btn-un", "btn-un","btn-error","btn-overs",
            ],
            fileId:'',//文件Id
            EchoState:true,
            tableList:[
            ],
            technologicalStatusMask1:false,
            changePage:'',
            tabelListSize:0,
            pageIndex:1,
            pageNum:'10',
            modalHeight:'600',
            technologicalStatusMask:false,
            modal0FileStatus:false,
            msg:'',
            modalShowToast:false,
            technologicalStatus:false,
            imgSataus:'',
            Modal3delectStatusImgStatus:'',
            delectStatus:false,
            nextStepStatus0:false,
            nextStepStatus1:false,
            nextStepStatus2:false,//
            progressMsg:0,
            msgloding:0,
            result_status:1,
            fileSoureState:'',
            fileModal3Soure:'',
            updateShow:false,
            nextIndex:0, //流程index

            modal0pre:{
                status:false,
                speed:0,
            },
            modal1pre:{
                status:false
            },
            modal2pre:{
                status:false,
            },
            modal3pre:{
                status:false,
            },

            // model3->>

            Modal3delectStatus:"1",
            imge:"../../assets/zmning//icon_stpe_1.png", //默认流程图1
            fromData:{
                name:{
                    text:'',
                    rules:false,
                    state:false,
                },
                phone:{
                    text:'',
                    rules:false
                },
                projectName:{
                    text:'',
                    rules:true
                },
                projectManName:{
                    text:'',
                    rules:true
                },
            },
            request:false,
            ids:'',
            eventData:0,
            // 验证结果
            resultState:false,
            result_img:false,
            result_loding:false,
            result_msg:'',
            result_detail:'',
            result_list:[
                {result_msg:"申请完成",result_detail:'您的申请已提交，请稍后，大约10分钟后，为您生成啄木鸟报告',overImg:'over'},
                {result_msg:"文件上传失败",result_detail:'请检查您的文件格式是否正确，或网络环境是否稳定',overImg:'error'},
                {result_msg:"次数用完了",result_detail:'您的啄木鸟分析报告免费次数已经用完',overImg:'speed0.png'},
            ],
    }
  },
  mounted () {
    this.getTableList();
    this.getFreeTimes()
    // let a = this.$cookies.get("inputVo")
    // let b  = this.$cookies.keys() 
    // console.log(unescape(a))
    // console.log(b)
  },
  computed: {
      show:function(){
                return this.pagesize && this.pagesize !=1
            },
            pstart: function() {
                return this.pageIndex == 1;
            },
            pend: function() {
                return this.pageIndex == this.pagesize;
            },
            efont: function() {
                if (this.pagesize <= 7) return false;
                return this.pageIndex > 5
            },
            ebehind: function() {
                if (this.pagesize <= 7) return false;
                var nowAy = this.indexs;
                return nowAy[nowAy.length - 1] != this.pagesize;
            },
            indexs: function() {

                var left = 1,
                    right = this.pagesize,
                    ar = [];
                if (this.pagesize >= 7) {
                    if (this.pageIndex > 5 && this.pageIndex < this.pagesize - 4) {
                        left = Number(this.pageIndex) - 3;
                        right = Number(this.pageIndex) + 3;
                    } else {
                        if (this.pageIndex <= 5) {
                            left = 1;
                            right = 7;
                        } else {
                            right = this.pagesize;

                            left = this.pagesize - 6;
                        }
                    }
                }
                while (left <= right) {
                    ar.push(left);
                    left++;
                }
                return ar;
            },

            modalBoxHeight(){
                return  Number(this.modalHeight) + 110
            },
            //处理流程图动态图片
            transitionName(){
                return this.modalShowToast == true ? 'transitionLeft' : 'transitionRight'
            },
            fifterImg(){
                return "@/assets/zmning/icon0.png";
            },
            overImg(){
                return "../../assets/zmning/"+this.result_img+'.png';
            },
            rulesDataStatus(){
                if(this.fromData.name.rules &&  this.fromData.phone.rules)  {return true}
            }
  },
  methods: {
    getFreeTimes(){
        getFreeTimes().then(res=>{
            this.freetime = res.data.free_times
        })
    },
    handleSearch() {
        // this.$nextTick(this.getDataList)
        this.getTableList()
    },
    gets:function(status){
        if(this.freetime <= 0){
             this.$message('免费次数已用完！')
             return
        }
     
       let data = {
                    channelId:2
                }
                this.technologicalStatus = 1
                this.technologicalStatusMask = 1
                judgeFreeTimes(data).then(res=>{
                    if(res.success == 1){
                        this.getTableList()
                        this.technologicalStatus = status
                        this.technologicalStatusMask = status
                    } else {
                        this.getResultData(this.result_list[2],2)
                    }
                })
                // this.uloadPost('/bfe/guarantee/bidingCheck/judgeFreeTimes.htm',data,(res)=>{
                //     if(res.data.success == 1){
                //         this.getTableList()
                //         this.technologicalStatus = status
                //         this.technologicalStatusMask = status
                //     } else {
                //         this.getResultData(this.result_list[2],2)
                //     }
                // }) 
    },
       jumpPage: function(id) {
                this.pageIndex = id;
                this.getTableList()
            },
            gopage(index){
                this.pageIndex = index;
                this.number_active = index -1
                this.getTableList()
            },
            gopageBack(){
                // this.pageIndex --
                if( this.pageIndex - 1 == 0 ){
                    return
                }else {
                    this.pageIndex -= 1
                    this.getTableList()
                }
            },
            gopageNext(){
                // this.pageIndex++
                if( this.pageIndex+1 > this.pagesize){
                    return
                }else {
                    this.pageIndex += 1
                    this.getTableList()
                }
            },
            errorStatusOver(){
                this.errorStatus   = false
            },
            getStatusNextClick(item,key,id){
                console.log(key);
                console.log(item,key,id);
                if(key == 3){
                }else  if(key == 4){
                    this.errorStatus = true
                    this.errortext  = "订单生成失败，请检查上传模板无误"
                }else if(key == 0 || key == 1){
                    const obj ={id:item.id}
                    console.log(obj);
                    selectOrderMessage(obj).then(res=>{
                        if(res.data.success == 1){
                            if( res.data.data.operationIndex == 1){
                                this.modalHeight = 550
                            }else {
                                this.modalHeight = 350
                            }
                            this.ids = item.id
                            this.technologicalStatusMask  = true
                            this.technologicalStatus = true
                            this.EchoState = false
                            this.fileId =res.data.data.excelFileId
                            this.nextIndex = res.data.data.operationIndex
                            this.fromData.name.text =res.data.data.linkName
                            this.fromData.phone.text = res.data.data.linkPhone
                            this.fromData.projectName.text = res.data.data.packageName
                            this.fromData.projectManName.text = res.data.data.companyName
                        }else {

                            this.errorStatus = true
                            this.errortext = "查询失败"
                        }
                    })
                    // this.uloadPost('/bfe/guarantee/bidingCheck/selectOrderMessage.htm',{id:item.id},(res)=>{
                    //     if(res.data.success == 1){
                    //         if( res.data.data.operationIndex == 1){
                    //             this.modalHeight = 550
                    //         }else {
                    //             this.modalHeight = 350
                    //         }
                    //         this.ids = item.id
                    //         this.technologicalStatusMask  = true
                    //         this.technologicalStatus = true
                    //         this.EchoState = false
                    //         this.fileId =res.data.data.excelFileId
                    //         this.nextIndex = res.data.data.operationIndex
                    //         this.fromData.name.text =res.data.data.linkName
                    //         this.fromData.phone.text = res.data.data.linkPhone
                    //         this.fromData.projectName.text = res.data.data.packageName
                    //         this.fromData.projectManName.text = res.data.data.companyName

                    //     }else {

                    //         this.errorStatus = true
                    //         this.errortext = "查询失败"
                    //     }
                    // })
                }else if(key == 5 ){
                    if(id == null || id == '' || id == undefined) return
                    console.log(id);
                    // window.open(`/zcjf/base/file/download/${id}`)
                    download(id)
   
                }

                // let result = {
                //     '3':()=>{
                //         //报告生成中
                //         // this.errorStatus = true;
                //         console.log(" 报告生成中")
                //     },
                //     '4' : ()=>{
                //         //报告未完成
                //
                //     },
                //     '5': ()=>{
                //         //报告可以下载
                //
                //
                //
                //     }
                // }
                //
                //  result.key()
                //  console.log(result.key)
            },

            getTableList() {
                const params= {
                    current: this.pagination.current,
                    size: this.pagination.size,
                }
                queryOrderMessage(params).then(response=>{
                    // if (response.data.success == 2) {
                    //     this.resultDataMsgStatus = false
                    //     this.tableList = []
                    //     this.tabelListSize = 0
                    //     this.freetime  =  response.data.freeTimes
                    //     return
                    // }
                    // this.tabelListSize = response.data.message.length
                    this.resultDataMsgStatus = true
                    this.tableList = response.data.records
                    this.pagination.total = response.data.total
                    if(this.tableList.length===0){
                        this.resultDataMsgStatus = false
                        this.tableList = []
                        this.tabelListSize = 0
                    }
                    // this.freetime  =  response.data.freeTimes
                    // this.pagesize = response.data.pageSize || 0
                })
                // this.$axios.get('/bfe/guarantee/bidingCheck/queryOrderMessage.htm', {
                //     params: {
                //         pageIndex: this.pageIndex,
                //         pageNum: this.pageNum,
                //         // beginTime:"",
                //         // endTime:"",
                //         // orderStatus:""

                //     }
                // }).then((response) => {
                //     if (response.data.success == 2) {
                //         this.resultDataMsgStatus = false
                //         this.tableList = []
                //         this.tabelListSize = 0
                //         this.freetime  =  response.data.freeTimes
                //         return
                //     }
                //     this.tabelListSize = response.data.message.length
                //     this.resultDataMsgStatus = true
                //     this.tableList = response.data.message
                //     this.freetime  =  response.data.freeTimes
                //     this.pagesize = response.data.pageSize || 0
                // })
                    
            },
            initPage() {
                this.getTableList()
            },
            closePop() {
                this.technologicalStatus = false
                this.technologicalStatusMask = false
                this.result_over()
                this.setData()
            },
            result_over() {
                // let fromData ={
                //     execlName:this.imgSataus,
                //     bidingName:this.Modal3delectStatusImgStatus,
                //     name: this.fromData.name.text,
                //     phone:this.fromData.phone.text,
                //     projectName:this.fromData.projectName.text,
                //     projectManName:this.fromData.projectManName.text
                // }
                this.getTableList();
                this.ShowTableList()
                if(this.result_status == 0){
                    this.setData()
                } else {
                   this.resultState  = false
                }
            },
            ShowTableList() {

            },
            technologicalClick(status) {
                let data = {
                    channelId:2
                }
                this.uloadPost('/bfe/guarantee/bidingCheck/judgeFreeTimes.htm',data,(res)=>{
                    if(res.data.success == 1){
                        this.getTableList()
                        this.technologicalStatus = status
                        this.technologicalStatusMask = status
                    } else {
                        this.getResultData(this.result_list[2],2)
                    }
                })
            },
            delectFile() {
                this.imgSataus = ''
                this.fileSoureState = "",
                document.getElementById('up').value = ''
            },
            backStepClick(index) {
                switch (index) {
                    case 1:
                        this.nextIndex = 0
                        this.modalHeight = 600
                        this.delectStatus = 1
                        break;
                    case 2:
                        this.nextIndex = 1
                        this.modalHeight = 550
                        break;
                }
            },
            //进行下一步
            nextStepClick(index) {
                this.MapsStepData(index)
                //下方模拟上传请求
            },
            getResultData(arr,index) {
                this.resultState = true
                this.result_img = arr.overImg;
                this.result_msg = arr.result_msg
                this.result_detail = arr.result_detail
                this.result_status = index
            },
            delectFileModal3() {
                this.modal0FileStatus = false
                this.fileModal3Soure = '',
                this.Modal3delectStatusImgStatus = ''
                document.getElementById('get').value = ''
            },
            delectFileModal2() {
                this.modal0FileStatus = false
                this.fileModal2Soure = '',
                this.Modal2delectStatus ='1',
                this.Modal2delectStatusImgStatus = ''
                document.getElementById('bidding').value = ''
            },
            resultImg(item){
                console.log(item);
                if(item == 0 || item == 1){
                    return  "../../assets/zmning/icon-process.png"
                }else {
                    return  "../../assets/zmning/iconOver.png"
                }

            },
            getExcelnextChange(){
                if (!this.nextStepStatus0) {
                    this.modalShowToast = true;
                    return false
                }
                if (!this.modal0pre.status && this.modal0pre.speed < 1) {
                    this.modal0pre.status = true
                }
                // if (this.modal0pre.speed == 100) {
                //     this.nextIndex = 1;
                //     this.modalHeight = 550
                // }
                this.delectStatus = 2
            },
            // 上传接口
            uploadFileAxios(url,data,method,FileNextcallback,FileonUploadProgressCallBack){
                this.request = true
                axios({
                    url,
                    method: method,
                    data: data,
                    headers: {},
                    //原生获取上传进度的事件
                    onUploadProgress: function (progressEvent) {
                      console.log(progressEvent)
                        let complete = (progressEvent.loaded / progressEvent.total * 100 | 0)
                        FileonUploadProgressCallBack(complete)
                    }

                }).then(res => {
                    this.request = false
                    FileNextcallback(res)
                })
            },
            uloadPost(url,data,callback){
                this.request = true
            this.$axios({
                    url,
                    method: 'post',
                    data: data,
                    headers: {},
                    //原生获取上传进度的事件
                   
                }).then(res => {
                    this.request = false
                    if(res.data.success == 0 ){

                    }
                    callback(res)
                })
            },
            MapsStepData(index) {
                switch (index) {
                    case 0:
                        if (!this.nextStepStatus0) {
                            // this.errorStatus  = true
                            // this.errortext ="请上传文件后进行下一步操作";
                            return} ;
                        if( this.request) return;
                        this.modal0pre.status = true
                        var formData = new FormData()
                        formData.append('file', this.fileSoureState);
                        
                        if(!this.modal0FileStatus){
                            const nweUrl = '/zcjf/biz/bfe/guarantee/bidingCheck/uploadFile'
                            this.uploadFileAxios(nweUrl,formData,'post',(res)=>{
                                console.log(res);
                                    if(res.data.data.status == 1) {
                                        this.dataList = {operationIndex: 1, channelId: 2, excelFileId: res.data.data.fileId,projectType:2,tenderFileId:""}
                                        this.fileId = res.data.data.fileId //保存第一步的文件Id
                                        this.delectStatus = 3
                                        this.Modal2delectStatus = 2
                                        this.EchoState = false
                                        var formDatas1 = new FormData();
                                        formDatas1.append('file',this.fileModal2Soure)
                                        this.uploadFileAxios(nweUrl,formDatas1,'post',(res)=>{
                                            if(res.data.success == 1) {
                                                this.tenderFileId = res.data.data.fileId
                                                this.dataList.tenderFileId = res.data.data.fileId
                                                this.modal3pre.status = true
                                                this.Modal2delectStatus = 2
                                                saveOrder(this.dataList).then(response=>{
                                                    if (response.data.success == 1 ){
                                                        this.nextIndex = 1
                                                        this.modal0pre.status = false
                                                        this.modal0pre.speed = 0
                                                        this.modal0FileStatus = true
                                                        this.modalHeight = 550
                                                        this.ids = response.data.id
                                                        this.EchoState = true
                                                    }else {
                                                        this.modal0pre.status = false
                                                        this.errorStatus = true
                                                        this.errortext =res.data.data.message
                                                    }
                                                })
                                            }else {
                                                this.getResultData(this.result_list[1],1)
                                            }
                                        }, (event)=>{this.modal3pre.speed = event;this.msgloding = event})
                                        // saveOrder(data).then(response=>{
                                        //     if (response.data.success == 1 ){
                                        //         this.nextIndex = 1
                                        //         this.modal0pre.status = false
                                        //         this.modal0pre.speed = 0
                                        //         this.modal0FileStatus = true
                                        //         this.modalHeight = 550
                                        //         this.ids = response.data.id
                                        //         this.EchoState = true
                                        //     }else {
                                        //         this.modal0pre.status = false
                                        //         this.errorStatus = true
                                        //         this.errortext =res.data.data.message
                                        //     }
                                        // })
                                    } else if(res.data.data.status == 0){
                                        this.delectStatus = 1
                                        this.modal0pre.status = false
                                        this.modal0pre.speed = 0
                                        this.getResultData(this.result_list[1],1)
                                    }
                            }, (event)=>{
                                    this.modal0pre.speed = event
                                    this.progressMsg = event
                            })
                        
                            // const nweUrl = '/zcjf/biz/bfe/guarantee/bidingCheck/uploadFile'
                            // this.uploadFileAxios(nweUrl,formData,'post',(res)=>{
                            //     console.log(res.data);
                            //         if(res.data.data.status == 1) {

                            //             let data = {operationIndex: 1, channelId: 2, excelFileId: res.data.data.fileId,projectType:2,tenderFileId:this.tenderFileId}
                            //             this.fileId = res.data.data.fileId //保存第一步的文件Id
                            //             this.delectStatus = 3
                            //             saveOrder(data).then(response=>{
                            //                 if (response.data.success == 1 ){
                            //                     this.nextIndex = 1
                            //                     this.modal0pre.status = false
                            //                     this.modal0pre.speed = 0
                            //                     this.modal0FileStatus = true
                            //                     this.modalHeight = 550
                            //                     this.ids = response.data.id
                            //                     this.EchoState = true
                            //                 }else {
                            //                     this.modal0pre.status = false
                            //                     this.errorStatus = true
                            //                     this.errortext =res.data.data.message
                            //                 }
                            //             })
                            //         } else if(res.data.data.status == 0){
                            //             this.delectStatus = 1
                            //             this.modal0pre.status = false
                            //             this.modal0pre.speed = 0
                            //             this.getResultData(this.result_list[1],1)
                            //         }
                            // }, (event)=>{
                            //         this.modal0pre.speed = event
                            //         this.progressMsg = event
                            // })
                            // console.log(datas.excelFileId,datas.tenderFileId);
                        }else {
                            this.nextIndex = 1
                            this.modal0pre.status = false
                            this.modal0pre.speed = 0
                            this.modalHeight = 550
                        }


                        break;
                    case 1:
                        if(Object.values(this.fromData).every((ele)=> ele.rules == true)){
                            if( this.request) return;
                            this.modal1pre.status   = true
                            this.EchoState = false
                            let data = {
                                linkName:this.fromData.name.text,
                                linkPhone:this.fromData.phone.text,
                                packageName:this.fromData.projectName.text,
                                companyName:this.fromData.projectManName.text,
                                operationIndex:2,
                                channelId:2,
                                id:this.ids,
                                projectType:2

                                // operation_index:2,
                            }
                            console.log(2222211);
                            saveOrder(data).then(res=>{
                                if(res.data.success == 1){
                                    this.modalHeight = 350
                                    this.nextIndex = 2
                                    this.modal1pre.status   = false
                                    this.EchoState = true
                                }else {
                                    this.errorStatus = true
                                    this.errortext =res.data.message
                                    this.modal1pre.status   = false
                                }
                            })
                            // this.uloadPost('/bfe/guarantee/bidingCheck/saveOrder.htm',data,(res)=>{
                            //     if(res.data.success == 1){
                            //         this.modalHeight = 350
                            //         this.nextIndex = 2
                            //         this.modal1pre.status   = false
                            //         this.EchoState = true
                            //     }else {
                            //         this.errorStatus = true
                            //         this.errortext =res.data.message
                            //         this.modal1pre.status   = false
                            //     }
                            // })
                        }else {
                            // this.modalShowToast = true
                            // this.errorStatus  = true
                            // this.errortext ="必填选项未填写或填写错误，请检查"
                        }
                        break;
                    case 2:
                        if(!this.nextStepStatus2) {
                            // this.errorStatus  = true
                            // this.errortext ="请上传文件后进行提交申请操作";
                            return}
                        if( this.request) return;
                        this.Modal3delectStatus = 2
                        this.EchoState = false
                        var formDatas = new FormData();
                        formDatas.append('file',this.fileModal3Soure)
                        const nweUrl = '/zcjf/biz/bfe/guarantee/bidingCheck/uploadFile'
                        this.uploadFileAxios(nweUrl,formDatas,'post',(res)=>{
                                this.modal2pre.status = true
                                if(res.data.success == 1) {
                                    let data = {
                                        channelId:2,
                                        fileId:res.data.data.fileId,
                                        excelFileId: this.fileId ,
                                        tenderFileId : this.dataList.tenderFileId,
                                        id:this.ids,
                                        projectType:2
                                    }
                                    saveOrder(data).then(response=>{
                                        if(response.data.success == 1){
                                            this.modal2pre.status   = false
                                            this.technologicalStatus = false

                                            this.getResultData(this.result_list[0],0)
                                            this.ids = ""
                                            this.EchoState = true
                                        }else {
                                            this.errorStatus  = true
                                            this.errortext ="保存失败"
                                            this.modal2pre.status   = false
                                        }
                                    })
                                }else {
                                    this.getResultData(this.result_list[1],1)
                                }
                            }, (event)=>{this.modal2pre.speed = event;this.msgloding = event})
                        break;
                }
            },
            update(e){
                //上传函数
                this.imgSataus = document.getElementById('up').files[0].name
                this.fileSoureState = document.getElementById('up').files[0]
                this.eventData = e
                document.getElementById('up').value = ''
                console.log(this.Modal2delectStatusImgStatus);
                this.nextStepStatus0 = true
            },
            updateM3(d){
                console.log(d);
                if(d==='1'){
                    this.Modal2delectStatusImgStatus  = document.getElementById('bidding').files[0].name
                    this.fileModal2Soure  = document.getElementById('bidding').files[0]
                    this.Modal2delectStatus = 0
                    this.nextStepStatus0 = true
                    
               
                    document.getElementById('bidding').value = ''
                    
                }else{
                    this.Modal3delectStatusImgStatus  = document.getElementById('get').files[0].name
                    this.fileModal3Soure  = document.getElementById('get').files[0]
                    this.Modal3delectStatus = 0
                    this.nextStepStatus2 = true
                
                    document.getElementById('get').value = ''
                }
                
            },
            update2(){
                console.log(111);
                
            },
            setData(){
                this.resultState =false
                this.technologicalStatusMask = false;
                this.modalHeight='600',
                    this.technologicalStatusMask=false,
                    this.modal0FileStatus=false,
                    this.msg='',
                    this.modalShowToast=false,
                    this.technologicalStatus=false,
                    this.imgSataus='',
                    this.delectStatus=false,
                    this.nextStepStatus0=false,
                    this.nextStepStatus1=false,
                    this.nextStepStatus2=false,//
                    this.progressMsg=0,
                    this.msgloding=0,
                    this.updateShow=false,
                    this.nextIndex=0, //流程index
                    this.modal0pre.status = false,
                    this.modal0pre.speed = 0
                this.modal1pre.status = false
                this.modal2pre.status =false,
                    // model3->>
                    this.Modal3delectStatusImgStatus='',
                    this.Modal2delectStatusImgStatus='',
                    this.Modal3delectStatus="1",
                    this.Modal2delectStatus="1",
                    this.imge="/webdocs/js/bfe/predict/bidingCheck/images/icon_stpe_1.png", //默认流程图1
                    this.fromData.name.rules = false
                this.fromData.projectName.rules = true
                this.fromData.phone.rules = false
                this.fromData.projectManName.rules = true
                this.fromData.name.text = ""
                this.fromData.phone.text = ""
                this.fromData.projectName.text = ""
                this.fromData.projectManName.text = ""
                // 验证结果
                this.resultState=false,
                    this. result_img=false,
                    this.result_loding=false,
                    this.result_msg='',
                    this.result_detail = ''
            },
  },
  watch: {
       tabelListSize(val){
                if(val == 0){
                    this.boxHeight = "800px"
                }else if(val < 3){
                    this.boxHeight = "100%"
                    // this.$refs.bodyapp.style.height == '100%'
                }else if(val >= 3){
                    this.boxHeight = "auto"
                    // this.$refs.bodyapp.style.height == 'auto'
                }
            },
            Modal3delectStatusImgStatus(val){
                if(val == ''){
                    this.nextStepStatus2 = false
                    this.Modal3delectStatus = 1
                }else {
                    this.Modal3delectStatus = 0
                    this.nextStepStatus2 = true
                }
            },
            imgSataus(val){
                if(val == ''){
                    this.delectStatus = 0
                    this.modal0FileStatus = false
                    this.modal0pre.status = false
                    this.modal0pre.speed = 0
                    this.progressMsg = 0
                    this.nextStepStatus0 = false
                }else {
                    this.delectStatus = 1
                    this.modal0FileStatus = false
                    this.nextStepStatus0 = true
                }
            },
            modalShowToast(state){
                if (state){
                    setTimeout(()=>{this.modalShowToast= false},2000)
                }
            },
            //监听进度条
            // TODO记得替换
            // msgloding(val){
            //     if (val == 100 ){
            //         this.modal2pre.status   = false
            //         this.technologicalStatus = false
            //         this.resultState = true
            //         this.getResultData(this.result_list[0])
            //         this.data = {}
            //     }
            // },
            // progressMsg(val) {
            //     if (val == 100 || !this.modal0pre.status && this.modal0FileStatus){
            //         this.nextIndex = 1
            //         this.delectStatus = 1
            //         this.modal0pre.status = false
            //         this.modal0pre.speed = val
            //         this.modalHeight = 550
            //     }
            // },
         
            'fromData.phone.text'( newValue){
                this.fromData.phone.state = true
                if((/^1[34578]\d{9}$/.test(newValue)) || (/^0\d{2,3}-?\d{7,8}$/).test(newValue)) {this.fromData.phone.rules =true ; } else {this.fromData.phone.rules =false}
            },
            'fromData.name.text'(newValue){
                this.fromData.name.state = true
                if(newValue) { this.fromData.name.rules = true ;this.fromData.name.state = true ;  } else  {this.fromData.name.rules = false}
            },
            rulesDataStatus(newval){
                if(newval){
                    this.nextStepStatus1 = true
                    return
                }else {
                    this.nextStepStatus1 = false
                    return
                }


            }
  }
}
</script>

<style lang='scss' scoped>
   [v-cloak]{
        display:none;
    }
/*标书啄木鸟公共基础样式 -- ie11 不支持 css变量 by lvyang*/
/*分页*/
* {
    margin: 0;
    padding: 0;
}

#containet {
    display: inline-block;
    padding: 19px;
    margin: auto;
}

#pageMain li {
    list-style: none;
    line-height: 22px;
}

#pageBox {
    padding: 10px 0 0 0;
}

#pageBox span {
    display: inline-block;
    width: 60px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #fff;
    background: #08a586;

}
.modal-pop-pop{
    position:absolute;left:0px;top:0px;
    background:rgba(0, 0, 0, 0.4);
    width:100%;  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
    height:100%;
    filter:alpha(opacity=60);  /*设置透明度为60%*/
    opacity:0.6;  /*非IE浏览器下设置透明度为60%*/
    z-Index:999;
}
#pageNav {
    display: inline-block;
}

#pageNav a {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #3a87ad;
    text-decoration: none;
}

#pageNav a.active, #pageNav a:hover {
    background: #3a87ad;
    color: #EFEFEF;
}

#prev:hover {
    cursor: pointer;
}

#next:hover {
    cursor: pointer;
}
/*默认table*/
/*带水平线*/
.table th{font-weight:bold}
.table th,.table td {
    height: 80px;
}
.loding{
    width: 1.6rem !important;
    height: 1.6rem !important;
}
.btndis{
    font-size: 16px !important;
}
.resultDataMsgStatus{
    width: 81%;
    margin: 0 auto;
    text-align: center;
}
.resultDataMsgStatus img{
    width: 100px;
    height: 80px;
    margin: 20px auto;
}
.tablelist {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.dhid{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
-webkit-box-orient: vertical;
}
[v-cloak]{
    display:none;
}
/*font*/
.font-size-small { font-size: 12px;}
.font-size-normal { font-size: 14px;}
.font-size-normal--16 { font-size: 16px;}
.font-size-big { font-size: 18px;}
.font-size-big--60 { font-size: 60px;}
.font-weight--bold{ font-weight: bold}
/*font*/
/*input*/
.input-normal {

}
.block {
    display: block;
}
.btn-normal{
    padding: 8px 17px;
    font-size: 14px;
    display: flex;
    justify-items: center;
    align-items: center;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.icon-process{
    background-image: url("../../assets/zmning/icon-process.png");
    background-size: 100% 100% ;
    width: 16px;
    height: 16px;
}
.icon-over{
    background-image: url("../../assets/zmning/iconOver.png");
    background-size: 100% 100% ;
    width: 16px;
    height: 16px;
}
.btn-error{
    background:#EB3941 ;
    border:#EB3941 solid 1px;
}

.btn-un{
    background:#999999 ;
    border:#999999 solid 1px;
}
.btn-overs{
    background:#007bff ;
    border:#007bff solid 1px;
}
.btn-process{
    background:#25B181 ;
    border:#25B181 solid 1px;
}
/*color--*/
.c-red{ color : #EB3941}
.c-blue{ color :#4086E6 }
.green { color :#25B181}
.c-normal { color :#333333}
.c-999 { color :#999999}

/*color--*/
.spanw{width: 150px;text-align: center;font-size: 16px}
/*magin*/
.m-30{ margin: 20px 30px}
.mt-15{ margin-top: 15px}
.mt-30 { margin-top: 30px }
.mb-30 { margin-bottom: 30px }
.ml-15 {margin-left: 15px}
.m-b{margin-bottom: 30px}
.ell{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
/*message*/
.c-message {
    position: fixed;
    top: 30px;
    left: 50%;
    /* transform:translateX(-50%); */
    height: 40px;
    line-height: 40px;
    background: #fff;
    min-width: 200px;
    color: #666;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    z-index: 9999;
}

.c-message--main {
    padding-left: 50px;
    padding-right: 20px;
}

.c-message--icon {
    color: #fff;
    width: 40px;
    height: 40px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    line-height: 40px;
}

.c-message--success {
    background: #13CE66 url(data:image/svg+xml;base64,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) no-repeat 0 50%;
}

.c-message--error {
    background: #FF4949 url(data:image/svg+xml;base64,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) no-repeat 0 50%;
}

.c-message--info {
    background: #20A0FF url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjQwcHgiIGhlaWdodD0iNDBweCIgdmlld0JveD0iMCAwIDQwIDQwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCAzOS4xICgzMTcyMCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+aWNvbl9pbmZvPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkVsZW1lbnQtZ3VpZGVsaW5lLXYwLjIuNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ik1lc3NhZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MC4wMDAwMDAsIC0xNTIuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSLluKblgL7lkJFf5L+h5oGvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MC4wMDAwMDAsIDE1Mi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJSZWN0YW5nbGUtMiI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Imljb25faW5mbyI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iIzUwQkZGRiIgeD0iMCIgeT0iMCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIj48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMS42MTUzODQ2LDI2LjU0MzIwOTkgQzIxLjYxNTM4NDYsMjYuOTQ3ODc1MSAyMS40NTgzMzQ4LDI3LjI5MTgzNjggMjEuMTQ0MjMwOCwyNy41NzUxMDI5IEMyMC44MzAxMjY4LDI3Ljg1ODM2ODkgMjAuNDQ4NzE5NCwyOCAyMCwyOCBDMTkuNTUxMjgwNiwyOCAxOS4xNjk4NzMyLDI3Ljg1ODM2ODkgMTguODU1NzY5MiwyNy41NzUxMDI5IEMxOC41NDE2NjUyLDI3LjI5MTgzNjggMTguMzg0NjE1NCwyNi45NDc4NzUxIDE4LjM4NDYxNTQsMjYuNTQzMjA5OSBMMTguMzg0NjE1NCwxOS43NDQ4NTYgQzE4LjM4NDYxNTQsMTkuMzQwMTkwNyAxOC41NDE2NjUyLDE4Ljk5NjIyOSAxOC44NTU3NjkyLDE4LjcxMjk2MyBDMTkuMTY5ODczMiwxOC40Mjk2OTY5IDE5LjU1MTI4MDYsMTguMjg4MDY1OCAyMCwxOC4yODgwNjU4IEMyMC40NDg3MTk0LDE4LjI4ODA2NTggMjAuODMwMTI2OCwxOC40Mjk2OTY5IDIxLjE0NDIzMDgsMTguNzEyOTYzIEMyMS40NTgzMzQ4LDE4Ljk5NjIyOSAyMS42MTUzODQ2LDE5LjM0MDE5MDcgMjEuNjE1Mzg0NiwxOS43NDQ4NTYgTDIxLjYxNTM4NDYsMjYuNTQzMjA5OSBaIE0yMCwxNS44MDQyOTgxIEMxOS40NDQ0NDI3LDE1LjgwNDI5ODEgMTguOTcyMjI0LDE1LjYxOTM2ODcgMTguNTgzMzMzMywxNS4yNDk1MDQ2IEMxOC4xOTQ0NDI3LDE0Ljg3OTY0MDYgMTgsMTQuNDMwNTI1NSAxOCwxMy45MDIxNDkxIEMxOCwxMy4zNzM3NzI2IDE4LjE5NDQ0MjcsMTIuOTI0NjU3NSAxOC41ODMzMzMzLDEyLjU1NDc5MzUgQzE4Ljk3MjIyNCwxMi4xODQ5Mjk1IDE5LjQ0NDQ0MjcsMTIgMjAsMTIgQzIwLjU1NTU1NzMsMTIgMjEuMDI3Nzc2LDEyLjE4NDkyOTUgMjEuNDE2NjY2NywxMi41NTQ3OTM1IEMyMS44MDU1NTczLDEyLjkyNDY1NzUgMjIsMTMuMzczNzcyNiAyMiwxMy45MDIxNDkxIEMyMiwxNC40MzA1MjU1IDIxLjgwNTU1NzMsMTQuODc5NjQwNiAyMS40MTY2NjY3LDE1LjI0OTUwNDYgQzIxLjAyNzc3NiwxNS42MTkzNjg3IDIwLjU1NTU1NzMsMTUuODA0Mjk4MSAyMCwxNS44MDQyOTgxIFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+) no-repeat 0 50%;
}

.c-message--warning {
    background: #F7BA2A url(data:image/svg+xml;base64,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) no-repeat 0 50%;
}

.c-message--close {
    position: absolute;
    right: 10px;
    color: #999;
    text-decoration: none;
    cursor: pointer;
    font-size: 30px;
    top: 0;
    line-height: 34px;
    display: block;
    height: 40px;
}

.c-message--close:hover {
    color: #666;
}

@keyframes messageFadeInDown {
    0% {
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0)
    }
    100% {
        -webkit-transform: none;
        transform: none
    }
}
.transitionBody{
    transition: all 0.3s ease; /*定义动画的时间和过渡效果*/
}

.transitionLeft-enter,
.transitionRight-leave-active {
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
    /*当左滑进入右滑进入过渡动画*/
}

.transitionLeft-leave-active,
.transitionRight-enter {
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100%, 0);
}
.c-message.messageFadeInDown {
    -webkit-animation-duration: .6s;
    animation-duration: .6s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both ;-webkit-animation-name: messageFadeInDown;
    animation-name: messageFadeInDown;
}

@keyframes messageFadeOutUp {
    0% {
        opacity: 1
    }
    100% {
        opacity: 0;
        -webkit-transform: translateY(-100%);
        transform: translateY(-100%)
    }
}

.c-message.messageFadeOutUp {
    -webkit-animation-duration: .6s;
    animation-duration: .6s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both ;-webkit-animation-name: messageFadeOutUp;
    animation-name: messageFadeOutUp
}


/* .c-message--tip{
    text-align: center;
} */


/*message*/
/*magin*/
/*button tig*/
.tooltip {position: absolute;z-index: 1070;display: block;font-size: 12px;line-height: 1.4;visibility: visible;filter: alpha(opacity=0);opacity: 0}
.tooltip.in {filter: alpha(opacity=90);opacity: .9}
.tooltip.top {padding: 5px 0;margin-top: -3px}
.tooltip.right {padding: 0 5px;margin-left: 3px}
.tooltip.bottom {padding: 5px 0;margin-top: 3px}
.tooltip.left {padding: 0 5px;margin-left: -3px}
.tooltip-inner {max-width: 200px;padding: 3px 8px;color: #fff;text-align: center;text-decoration: none;background-color: #000;border-radius: 4px}
.tooltip-arrow {position: absolute;width: 0;height: 0;border-color: transparent;border-style: solid}
.tooltip.top .tooltip-arrow {bottom: 0;left: 50%;margin-left: -5px;border-width: 5px 5px 0;border-top-color: #000}
.tooltip.top-left .tooltip-arrow {bottom: 0;left: 5px;border-width: 5px 5px 0;border-top-color: #000}
.tooltip.top-right .tooltip-arrow {right: 5px;bottom: 0;border-width: 5px 5px 0;border-top-color: #000}
.tooltip.right .tooltip-arrow {top: 50%;left: 0;margin-top: -5px;border-width: 5px 5px 5px 0;border-right-color: #000}
.tooltip.left .tooltip-arrow {top: 50%;right: 0;margin-top: -5px;border-width: 5px 0 5px 5px;border-left-color: #000}
.tooltip.bottom .tooltip-arrow {top: 0;left: 50%;margin-left: -5px;border-width: 0 5px 5px;border-bottom-color: #000}
.tooltip.bottom-left .tooltip-arrow {top: 0;left: 5px;border-width: 0 5px 5px;border-bottom-color: #000}
.tooltip.bottom-right .tooltip-arrow {top: 0;right: 5px;border-width: 0 5px 5px;border-bottom-color: #000}
/*button*/
.progress,.progress-bar,.sr-only{height:10px; font-size:0;line-height:0 }
.progress{  margin: 30px 0px;overflow:hidden; width:200px;-khtml-border-radius:6px;-ms-border-radius:6px;-o-border-radius:6px;-moz-border-radius:6px;-webkit-border-radius:6px;border-radius:6px}
.progress-bar{width:100%;background-color:#efefef     ;height: 18px;
    background:linear-gradient(45deg,#fc0 0%,#fc0 20%,#fa0 20%, #fa0 45%,#fc0 45%,#fc0 70%,#fa0 70%, #fa0 95%,#fc0 95%,#fc0 100%);
    background:linear-gradient(45deg,#4086E6 0%, #6cc7e6 20%,#6cc7e6 20%, #6cc7e6 45%,#4086E6 45%,#4086E6 70%,#6cc7e6 70%, #6cc7e6 95%,#4086E6 95%,#4086E6 100%);
    background-size:30px 30px;
    background-position:0 0;
    animation:click 1s infinite linear;
}
.page {
    font-weight: 900;
    height: 40px;
    text-align: center;
    color: #888;
    margin: 20px auto 0;

}
.noneHeight{
    height: 800px;
}

.pagelist {
    font-size: 0;
    background: #fff;
}

.pagelist span {
    font-size: 14px;
}

.pagelist .jump {
    border: 1px solid #ccc;
    padding: 5px 8px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 5px;
}

.pagelist .bgprimary {
    cursor: default;
    color: #fff;
    background: #337ab7;
    border-color: #337ab7;
}

.jumpinp input {
    width: 55px;
    height: 26px;
    font-size: 13px;
    border: 1px solid #ccc;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    text-align: center;
}

.ellipsis {
    padding: 0px 8px;
}

.jumppoint {
    margin-left: 30px;
}

.pagelist .gobtn {
    font-size: 12px;
}

.bgprimary {
    cursor: default;
    color: #fff;
    background: #337ab7;
    border-color: #337ab7;
}
.pagelist .jump.disabled{
    pointer-events: none;
    background: #ddd;
}
@keyframes click {
    0%{
        background-position:0 0;
    }
    100%{
        background-position:30px 0;
    }
}
.sr-only{display:inline-block; background-color:#58b957}
.flex-colum {
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    align-items: center;
}
.dis{
    cursor:not-allowed !important;
}
.nor{
    cursor:pointer !important;
}
.flex{

    display: flex;
    justify-content:space-between ;
    align-items: center;
}

.center-m{
    margin: 0 auto;
}
.main{
    width: 1150px;
    padding: 0;
}
.bander-main{
    height: 220px;
    display: flex;
}
.bander-main .bander-main-left {
    background-image:url("../../assets/zmning/bander.png") ;
    height: 220px;
    width: 826px;
    background-size:100% 100% ;
}
.close-icons{
    background-size: 100% 100% ;
    background-image: url("../../assets/zmning/close.png");
    width: 22px;
    height: 22px;
    transition: .3s;
    position: absolute;
    right: 30px;
    top:30px
}
.close-icon:hover{

}
.bander-main .bander-main-right {
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    background:#4086E6 ;
    height: 220px;
    width: 294px;
    background-size:100% 100% ;
}
.p-30{
    padding-top: 30px;
}
.bander-main-right--number {
    font-family: PingFangSC-Semibold;
    font-size: 60px;
    color: #FFFFFF;
    text-align: center;
    line-height: 60px;
    margin-top: 30px;
    margin-bottom: 12px;
}
.bander-main-right--lastcheck {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 16px;
    margin-bottom: 24px;
}
.bander-main-right-btn{
    border-radius: 29px;
    background: #ffffff;
    width: 254px;
    height: 58px;
    text-align: center;
    line-height: 59px;
    font-size: 18px;
    color: #4086E6;
    font-weight: bold;
    margin: 0 auto;

}

.mask{
    position:absolute;left:0px;top:0px;
    background:rgba(0, 0, 0, 0.4);
    width:100%;  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
    height:100%;
    filter:alpha(opacity=60);  /*设置透明度为60%*/
    opacity:0.6;  /*非IE浏览器下设置透明度为60%*/
    z-Index:999;
}
.modal-pop{
    border-radius: 10px;
    position:absolute;
    width:600px;
    height:617px;
    top:47%;
    left:50%;
    background-color:#fff;

    z-Index:1000;
    margin-top: -308px;
    margin-left: -300px;
}
.modal-process{
    width: 100%;
    height: 49px;
    margin: 40px auto;
}
.modal-process img{
    width: 100%;
    height: 49px;
    margin: 0 auto;
}
.modal-process-box{
    width: 100%;
    display: flex;
    justify-content: space-around;
}
.modal-process-box--left{
    background: #F1F1F1;
    border: 1px dashed  #999999;
    border-radius: 10px;
    width: 200px;
    height: 226px;
    display: flex;
    flex-direction: column;
    align-items: center;

}
.modal-process-box--left img{
    margin: 30px;
    width: 60px;
    height: 60px;
}
.modal-process-box-span{
    width: 136px;
    height: 57px;
    font-size: 16px;
    font-weight: bold;
    p{
        text-align: center;
    }
}

.btn-over {
    color: #fff !important;
    background-color: #999999 !important;
    border-color: #999999 !important;
}
.icon_active{
    background-image: url("../../assets/zmning/activeIcon.png");
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
}
.icon_un{
    background-image: url("../../assets/zmning/unactiveIcon.png");
    width: 16px;
    height: 16px;
    background-size: 100% 100%;
}

.modal-foote{
    width: 100%;
    background: #eeeeee;
    display: flex;
    justify-content: flex-end;
    border-radius:0 0 10px 10px;
}
.modal-foote-center{
    width: 100%;
    background: #eeeeee;
    display: flex;
    justify-content:  space-between;;
}
.modal-process-box-span span{
    color: #151515;
}
.modal-process-box--right{
    background: #F1F1F1;
    border: 1px dashed  #999999;
    border-radius: 10px;
    width: 200px;
    height: 226px;
    display: flex;
    flex-direction: column;
    align-items: center;

}
.modal-process-box--right img{
    width: 60px;
    height: 60px;
    margin: 30px;
}
.modal-process-box-size{
width: 80px;
    height: 7px;
}
.modal-process-box--p{
    justify-items: center;
    justify-content: center;
    color: #999999;
    height: 226px;
    text-align: center;
    display: flex;
    flex-direction: column;
}
.tell{
    margin: 10px 0;
    color: #EB3941 ;
    font-size: 14px;
    display: block;
    font-weight: bold;
}
button{
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
}
.Disable-btn{
    height: 40px;
    margin: 15px;
    background: #999999;
    border-radius: 4px;
    color: #fff;
    width: 125px;
    border-color: #999999;
}
table{width:100%;empty-cells:show;background-color:transparent;border-collapse:collapse;border-spacing:0;font-size: 14px}
table th{text-align:left; font-weight:400}
/*带水平线*/
.table th{font-weight:bold}
.table th,.table td {


}

.dhid{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.table td{text-align:left}
.table tbody tr.success > td{background-color:#dff0d8}
.table tbody tr.error > td{background-color:#f2dede}
.table tbody tr.warning > td{background-color:#fcf8e3}
.table tbody tr.info > td{background-color:#d9edf7}
.table tbody + tbody{border-top:2px solid #ddd}
.table .table{background-color:#fff}
table tr:nth-child(odd){
    background: #EBF4FF;
}
/*带分割线*/
.table-border{border-top:1px solid #ddd;border-left:1px solid #ddd;border-right:1px solid #ddd;  table-layout:fixed}
.table-border th,.table-border td{border-bottom:1px solid #ddd}
#pageMain{
    height: 500px;
}
/*th带背景*/
.table-bg thead th{background-color:#F5FAFE}
/*带外边框*/
.table-bordered{border:1px solid #ddd;border-collapse:separate;*border-collapse:collapse;border-left:0}
.table-bordered th,.table-bordered td{border-left:1px solid #ddd}
.table-border.table-bordered{border-bottom:0}

/*奇数行背景设为浅灰色*/
.table-striped tbody > tr:nth-child(odd) > td,.table-striped tbody > tr:nth-child(odd) > th{background-color:#f9f9f9}
/*竖直方向padding缩减一半*/
.table-condensed th,.table-condensed td{padding:4px 5px}
/*鼠标悬停样式*/
.table-hover tbody tr:hover td,.table-hover tbody tr:hover th{background-color: #f5f5f5}
/*定义颜色*/
/*悬停在行*/
.normal {

}
.table tbody tr.active,.table tbody tr.active>td,.table tbody tr.active>th,.table tbody tr .active{background-color:#ffffff!important}


/*表格文字对齐方式，默认是居左对齐*/
.table .text-c th,.table .text-c td{text-align:center}/*整行居中*/
.table .text-r th,.table .text-r td{text-align:right}/*整行居右*/
.table th.text-l,.table td.text-l{text-align:left!important}/*单独列居左*/
.table th.text-c,.table td.text-c{text-align:center!important}/*单独列居中*/
.table th.text-r,.table td.text-r{text-align:right!important}/*单独列居右*/

.normal-btn{
    width: 125px;
    height: 40px;
    margin: 15px;
    line-height: 40px;
}
.afer{
font-size: 14px;
    font-weight: normal;
    margin-left: 8px;
}
.befor{
    font-family: fantasy;
    font-size: 32px;
    margin-left: 5px;
    font-weight: normal;
}
normal-btn:before {
    content: '';
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-right: 0.5em;
    color: #007bff;
    border: 1px solid #007bff;
    border-radius: 50%;
    vertical-align: -10%;
    clip-path: polygon(0% 0%, 100% 0%, 100% 30%, 0% 30%);
    animation: rotate 1s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotatez(0deg);
    }

    to {
        transform: rotatez(360deg);
    }
}
html, body {
    position: relative;
    height: 100%;
}
td{
    white-space:normal;
    word-wrap:break-word
}
body {
    background: #eee;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color:#000;
    margin: 0;
    padding: 0;
}
.swiper-container {
    width: 100%;
    height: 100%;
}
.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}
.modele-box--end{
    width: 540px;
    padding: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
      border: 1px dashed  #999999;
    border-radius: 10px;
    height: 100px;
    margin-top: 15px;
}
.result-modal-box{
    border-radius: 10px;
    position:absolute;
    width:400px;
    height:292px;
    top:50%;
    left:50%;
    background-color:#fff;
    cursor:pointer;
    z-Index:9999;
    margin-top: -147px;
    margin-left: -200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.result-modal-box img{
    width:69px
}
.result-modal-box span {
    width: 310px;
}
.modal-mask{
    position:absolute;left:0px;top:0px;
    background:rgba(0, 0, 0, 0.4);
    width:100%;  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
    height:100%;
    filter:alpha(opacity=60);  /*设置透明度为60%*/
    opacity:0.6;  /*非IE浏览器下设置透明度为60%*/
    z-Index:999;
}
.modal-pop--loding{
    border-radius: 10px;
    position:absolute;
    top:50%;
    left:50%;
    cursor:pointer;
    z-Index:9999;
}
@keyframes slideIn {

    0% {

        transform: scale(0);

    }

    100% {

        transform: scale(1);

    }

}

@keyframes slideOut {

    0% {

        transform: scale(1);

    }

    100% {

        transform: scale(0);

    }

}

.slide-enter-active {

    animation: slideIn .5s;

}

.slide-leave-active{

    animation: slideOut .5s;

}
.fade-enter-active, .fade-leave-active {
     transition: opacity 1s
 }
.fade-enter, .fade-leave-active {
    opacity: 0
}

.slide-enter-active{

    animation: slideIn .5s;

}

.slide-leave-active{

    animation: slideOut .5s;

}
table{width:100%;empty-cells:show;background-color:transparent;border-collapse:collapse;border-spacing:0;font-size: 14px}
table th{text-align:left; font-weight:400}
/*带水平线*/
.table th{font-weight:bold}
.table th,.table td {
    vertical-align: inherit !important ;

}
.tablelist {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.dhid{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.table td{text-align:left}
.table tbody tr.success > td{background-color:#dff0d8}
.table tbody tr.error > td{background-color:#f2dede}
.table tbody tr.warning > td{background-color:#fcf8e3}
.table tbody tr.info > td{background-color:#d9edf7}
.table tbody + tbody{border-top:2px solid #ddd}
.table .table{background-color:#fff}
table tr:nth-child(odd){
    background: #EBF4FF;
}
/*带分割线*/
.table-border{border-top:1px solid #ddd;border-left:1px solid #ddd;border-right:1px solid #ddd;  table-layout:fixed}
.table-border th,.table-border td{border-bottom:1px solid #ddd}
#pageMain{
    height: 500px;
}
/*th带背景*/
.table-bg thead th{background-color:#F5FAFE}
/*带外边框*/
.table-bordered{border:1px solid #ddd;border-collapse:separate;*border-collapse:collapse;border-left:0}
.table-bordered th,.table-bordered td{border-left:1px solid #ddd}
.table-border.table-bordered{border-bottom:0}

/*奇数行背景设为浅灰色*/
.table-striped tbody > tr:nth-child(odd) > td,.table-striped tbody > tr:nth-child(odd) > th{background-color:#f9f9f9}
/*竖直方向padding缩减一半*/
.table-condensed th,.table-condensed td{padding:4px 5px}
/*鼠标悬停样式*/
.table-hover tbody tr:hover td,.table-hover tbody tr:hover th{background-color: #f5f5f5}
/*定义颜色*/
/*悬停在行*/
.normal {

}
.table tbody tr.active,.table tbody tr.active>td,.table tbody tr.active>th,.table tbody tr .active{background-color:#ffffff!important}


/*表格文字对齐方式，默认是居左对齐*/
.table .text-c th,.table .text-c td{text-align:center}/*整行居中*/
.table .text-r th,.table .text-r td{text-align:right}/*整行居右*/
.table th.text-l,.table td.text-l{text-align:left!important}/*单独列居左*/
.table th.text-c,.table td.text-c{text-align:center!important}/*单独列居中*/
.table th.text-r,.table td.text-r{text-align:right!important}/*单独列居右*/
.el-pagination{
      margin: 20px 0;
      text-align: center;
    }
    .bidding{
        width: 520px;
        margin-left: 10px;
        background-color: #F1F1F1;
        margin-bottom: 20px;
    }
    .download{
        text-align: center;
        a{
            display: block;
           
            
            span{
                 color: rgb(0, 123, 255);
                border-bottom: 1px solid rgb(0, 123, 255);
            }
        }
    }
    .el-Tooltip{
        background-color: #fff;
    }
</style>
<style>

.atooltip1 {
  background: #F1F1F1 !important;
  color: #333 !important;

}
.atooltip1.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  border-left-color: #F1F1F1 !important;
}
.atooltip1.el-tooltip__popper[x-placement^="left"] .popper__arrow:after {
  border-left-color: #F1F1F1 !important;
}
.atooltip2 {
  background: #F1F1F1 !important;
  color: #333 !important;

}
.atooltip2.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  border-right-color: #F1F1F1 !important;
}
.atooltip2.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
  border-right-color: #F1F1F1 !important;
}
.form-control {
    display:block;
    width:100%;
    height:34px;
    padding:6px 12px;
    font-size:14px;
    line-height:1.42857143;
    color:#555;
    background-color:#fff;
    background-image:none;
    border:1px solid #ccc;
    border-radius:4px;
    -webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow:inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition:border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s
}
.btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.btn-outline-primary {
    color: #007bff;
    border-color: #007bff;
    text-align: center;
    border: 1px solid #007bff;
    line-height: 30px !important;
}
</style>
